import { render, staticRenderFns } from "./MarkdownSection.vue?vue&type=template&id=4c6aa36b&scoped=true"
import script from "./MarkdownSection.vue?vue&type=script&lang=js"
export * from "./MarkdownSection.vue?vue&type=script&lang=js"
import style0 from "./MarkdownSection.vue?vue&type=style&index=0&id=4c6aa36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6aa36b",
  null
  
)

export default component.exports